import React from "react";
import { ArrowLeft } from "lucide-react";

// R5 — extraído MECANICAMENTE de pages/NewOperation.jsx (JSX verbatim; o
// estado vive no componente-pai e chega por `ctx`).
export default function WizardHeader({ ctx }) {
  const {
    cfg,
    backPath,
    totalSteps,
    requestExit,
  } = ctx;
  return (
    <div>
      <button
        onClick={() => requestExit(backPath)}
        className="text-[13px] text-zinc-500 hover:text-zinc-800 inline-flex items-center gap-1.5"
        data-testid="back-to-operations"
      >
        <ArrowLeft className="h-3.5 w-3.5" /> {cfg.copy.voltar}
      </button>
      <h1 className="mt-3 text-3xl sm:text-[34px] font-semibold tracking-tight">{cfg.copy.titulo}</h1>
      <p className="text-sm text-zinc-500 mt-1">
        {cfg.copy.subtitulo(totalSteps)}
      </p>
    </div>
  );
}
